<template>
	<div class="page-box">
		<div v-if="loading" class="loading-box">
			<div id="rearviewLoadContainer">
				<p class="text">Your Year In Review is Loading...</p>
			</div>
		</div>
		<div v-else class="content">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PageDisplay',
	props: {
		loading: {
			type: Boolean,
			default: false
		},
		loadNum: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			processBar: null
		}
	},
	watch: {
		loadNum(newVal) {
			this.showLoadAni(newVal, 300)
		}
	},
	mounted() {
		this.showLoadAni(this.loadNum)
	},
	methods: {
		showLoadAni(loadNum, time = 1200) {
			const ProgressBar = require('progressbar.js')

			if (!this.processBar) {
				this.processBar = new ProgressBar.Line('#rearviewLoadContainer', {
					strokeWidth: 4,
					easing: 'easeInOut',
					duration: time,
					color: '#FFEA82',
					trailColor: '#eee',
					trailWidth: 1,
					svgStyle: { width: '100%', height: '100%' },
					text: {
						style: {
							color: '#bbe1fa',
							position: 'absolute',
							right: '50%',
							top: '-45px',
							padding: 0,
							margin: 0,
							transform: 'translateX(50%)',
							fontSize: '36px',
							fontFamily: 'Gotham-Bold'
						},
						autoStyleContainer: false
					},
					from: { color: '#FFEA82' },
					to: { color: '#ED6A5A' },
					step: (state, bar) => {
						bar.setText(Math.round(bar.value() * 100) + ' %')
					}
				})

				this.processBar.animate(loadNum)
			} else {
				this.processBar.animate(loadNum, {
					duration: time
				})
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.page-box {
	.loading-box {
		height: calc(100vh);
		border-radius: 4px;
		box-shadow: 0 10px 20px 0 rgba(69, 73, 91, 0.08);
		background-color: #177cb0;
		display: flex;
		align-items: center;
		justify-content: center;
		.loading {
			width: 78px;
			height: 78px;
		}

		#rearviewLoadContainer {
			position: relative;
		}

		.text {
			position: absolute;
			top: 20px;
			right: 50%;
			width: 240px;
			transform: translateX(50%);
			font-size: 16px;
			color: #f1fcfc;
			font-family: SourceSansPro;
		}
	}
}
</style>